/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Empty,
  Select,
  message,
  Modal,
  Tooltip,
  Input,
  Dropdown,
  Menu,
  Checkbox
} from "antd";
import React, { useCallback, useEffect, useState, useMemo, useContext, useRef } from "react";
import classnames from "classnames";
import { connect } from "dvajs";
import { useTranslation } from "react-i18next";
import { EbookState, MangeExternalModalInfo } from "@/models/ebook";
import { changeEgovUrl } from "@/utils/tools";
import { ListItem } from "@jd/focus-desktop-comps";
import { debounce, get } from "lodash";
import { openUserCardModal } from "@/components/AddressBook/common";
import { ListItemData, labelInfoList } from "@jd/focus-desktop-comps/lib/es/ListItem";
import operationRecord from "@/assets/img/externalContacts/operationRecord.png";
import IconFont from "@/components/icon";
import {
  changeExtAccountStatus,
  getExtEmplOperateRecord,
  getManageExtEmpls,
  UserStatus,
  sendActiveMsg,
  transferEmpls
} from "@/api/ebook";
import { TitleDeptInfo } from "@/types/UserCard";
import { getDeptPositionDesc } from "@/models/user";
import dayjs from "dayjs";
import { convertUserToString } from "@/utils/chat/message";
import { analysisLog } from "@/utils/logAnalytics";
import noContent from "@/assets/img/search-nodata.png";
import { QuestionCircleOutlined } from "@/utils/antdIcon";
import { syncConfirmNew } from "@/utils/syncConfirm";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import config, { ConfigEnum } from "@/config/config";
import { UserState } from "@/types/chat/State";
import { ContactShowType, UserSelTab } from "@jd/focus-desktop-comps/lib/es/UserSelection";
import { InputPlacement } from "@jd/focus-desktop-comps/lib/es/UserSelectionModal/types";
import { DynamicObject } from "@/types/common";

import styles from "@/components/styles";
import "./index.less";
import GlobalContext from "@/context/GlobalContext";

const { Option } = Select;

enum OperateEnum {
  recovery = "recovery",
  delete = "delete",
  extend = "extend",
  stop = "stop",
  notice = "notice",
  transfer = "transfer"
}

// 允许的操作
const disallowOpts = {
  [OperateEnum.notice]: [
    UserStatus.UN_ENABLE,
    UserStatus.NORMAL,
    UserStatus.TRANSFERRING,
    UserStatus.UN_ENABLE_EXPIRE
  ],
  [OperateEnum.recovery]: [UserStatus.NORMAL, UserStatus.UN_ENABLE_EXPIRE, UserStatus.TRANSFERRING],
  [OperateEnum.extend]: [UserStatus.TRANSFERRING, UserStatus.UN_ENABLE],
  [OperateEnum.stop]: [UserStatus.UN_ENABLE, UserStatus.UN_ENABLE_EXPIRE, UserStatus.TRANSFERRING],
  [OperateEnum.delete]: [UserStatus.TRANSFERRING],
  [OperateEnum.transfer]: [UserStatus.TRANSFERRING]
};
const optTypeMap: DynamicObject = {
  [OperateEnum.transfer]: {
    title: "转交"
  },
  [OperateEnum.delete]: {
    title: "删除",
    content: `1.账号将立即无法使用。
2.归属于账号的会话消息、联系人关系、文档、任务、日程等数据将被删除或解除绑定，且\<span class="danger"\>无法恢复\<\/span\>

*建议先停用账号，完全确认不再使用后，再进行删除。`
  },
  [OperateEnum.recovery]: {
    title: "恢复",
    content: `1、账号可登录
2、可查看近7天数据，如消息、日程、共享文件等`
  },
  [OperateEnum.stop]: {
    title: "停用",
    content: `1.账号将无法登录，已登录账号将被踢出登录；
2.停用账号可以恢复，恢复后，可查看停用期间的数据。`
  },
  [OperateEnum.extend]: {
    title: "延期",
    content: `1、未过期账号将增加6个月的有效期。
2、已过期账号可正常登录，并增加6个月有效期`
  }
};

export function operationType(type: number) {
  switch (type) {
    case 0:
      return "账号产生";
    case 1:
      return "账号延期申请";
    case 2:
      return "账号延期成功";
    case 3:
      return "账号延期申请被驳回";
    case 4:
      return "账号延期";
    case 5:
      return "账号停用";
    case 6:
      return "账号恢复";
    case 7:
      return "管理者变更";
    default:
      break;
  }
}

export interface manageExternalInfo {
  appId: string;
  emplEnabled: number; // 账号状态, 0:停用, 1:正常
  fields?: [];
  isExternal: string;
  labelInfoList: labelInfoList[];
  partTimeTitleDeptInfo: TitleDeptInfo[];
  teamId: string;
  userId: string;
  status: number;
  userStatus: string;
  userType: string;
  validDate: number;
  version: string;
  open: boolean;
  checked?: boolean;
  records?: {
    time: number;
    desc: string;
    operateName: string;
    type: number; // 操作类型, 0:账号产生, 1:延期申请, 2:延期通过, 3:延期驳回, 4:延期, 5:停用, 6:恢复,7.管理者变更"
  }[];
}

const limit = 20;

function ManageExternal({
  manageExternalModal,
  userData,
  setManageExternalModal
}: {
  userData: any;
  manageExternalModal: MangeExternalModalInfo;
  setManageExternalModal: (payload: any) => void;
}) {
  const { appRuntimeEnv } = useContext(GlobalContext);
  const { visible } = manageExternalModal;
  const { gateway } = appRuntimeEnv.envConfig || {};
  const [t] = useTranslation("addressList");
  const page = useRef(1);
  const [total, setTotal] = useState(0);
  const [manageExternalList, setManageExternalList] = useState<manageExternalInfo[]>([]);
  const [selecting, setSelecting] = useState(false);
  const [expireTime, setExpireTime] = useState("");
  const [status, setStatus] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [_updater, setUpdater] = useState(0);
  const [selectedUser, setSelectedUser] = useState<any[]>([]);
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  function forceUpdate() {
    setUpdater((updater) => updater + 1);
  }

  const handleClose = useCallback(() => {
    if (!visible) {
      return;
    }
    setSelecting(false);
    setSelectedUser([]);
    setManageExternalModal({ visible: false });
    page.current = 1;
    setExpireTime("");
    setStatus("");
    setSearchVal("");
    setTotal(0);
    setManageExternalList([]);
  }, [setManageExternalModal, visible]);

  const getManageExternalModalList = useCallback(
    async function (keyword = "") {
      const [result, error] = await getManageExtEmpls({
        pageNo: page.current,
        pageSize: limit,
        keyword,
        status: status ? Number(status) : undefined,
        validDateLt: expireTime ? Number(expireTime) : undefined
      });
      if (error) {
        message.error(error);
        return;
      }
      const { total, emplList } = result;
      setTotal(total);
      setManageExternalList((prev) => {
        return prev.concat(
          emplList.map((item: any) => {
            return {
              ...item,
              ...item.partTimeTitleDeptInfo?.[0],
              name: item.fields.find((f: any) => f.key === "name")?.val,
              avatar: item.fields.find((f: any) => f.key === "avatar")?.val,
              refuse: false,
              loading: false,
              open: false,
              desc: getDeptPositionDesc({
                deptName: item.partTimeTitleDeptInfo?.[0]?.deptName || "",
                titleName: item.partTimeTitleDeptInfo?.[0]?.titleName || "",
                unitName: item.partTimeTitleDeptInfo?.[0]?.unitName || "",
                userType: item.userType
              })
            };
          })
        );
      });
    },
    [expireTime, status]
  );
  useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);

  useEffect(() => {
    if (visible) {
      getManageExternalModalList();
    } else {
      handleClose();
    }
  }, [visible, getManageExternalModalList, handleClose]);

  const batchList = useMemo(() => {
    return (
      manageExternalList
        // 批量操作，转交中的数据不展示。
        .filter((i) => (i.status & UserStatus.TRANSFERRING) !== UserStatus.TRANSFERRING)
    );
  }, [manageExternalList]);

  const reloadList = useCallback(() => {
    setManageExternalList([]);
    page.current = 1;
    setTotal(0);
    setStatus("");
    setSearchVal("");
    setExpireTime("");
    setSelectedUser([]);
    getManageExternalModalList();
  }, [getManageExternalModalList]);
  const toggleSelect = useCallback(() => {
    setSelectedUser([]);
    if (selecting) {
      manageExternalList.forEach((i: any) => {
        i.checked = false;
      });
    } else {
      analysisLog("xtbg_add_home_1637657110163", "93");
    }
    setSelecting(!selecting);
  }, [manageExternalList, selecting]);

  const handleBatchTransfer = useCallback(
    (users: manageExternalInfo[], isBatch?: boolean) => {
      if (!users.length) {
        message.error("请选择要转交的用户");
        return;
      }
      openUserSelectionDefaultModal(
        {
          title: "转交管理者",
          maxSelectedNum: 1,
          tabSort: [
            {
              tab: UserSelTab.recent,
              sort: 1
            }
          ],
          contactShowType: ContactShowType.innerSameTeam,
          tabs: !config[ConfigEnum.EXTERNAL_CONTACTS_ORG]
            ? ["recent", "group", "externalContacts"]
            : ["recent", "org", "group", "externalContacts"],
          inputPlacement: InputPlacement.bodyRightBottom,
          extraInput: {
            maxLength: 100,
            defaultValue: "申请将外部联系人交由您处理",
            placeholder: "转交原因",
            isTextArea: true
          },
          validate: async (data) => {
            const extraString = get(data, "data.extraString", []);
            if (!extraString) {
              message.error("转交原因必填");
              return Promise.reject(new Error("转交原因必填"));
            }
            return;
          }
        },
        // eslint-disable-next-line max-params
        async ({ data }, close, update, cancelLoading) => {
          try {
            const { result, extraString } = data || {};
            if (!extraString) {
              cancelLoading();
              return;
            }
            if (!result.length) {
              cancelLoading();
              return;
            }
            analysisLog("xtbg_add_home_1637657110163", "90");

            const [_res, err] = await transferEmpls({
              reason: extraString,
              userIds: users.map((i) => i.userId),
              toUserId: result[0].id.split(":")[0]
            });
            if (err) {
              console.error(err);
              message.error(err);
              cancelLoading();
              return;
            }

            reloadList();
            isBatch && toggleSelect();
            message.success("转交成功");
            close();
          } catch (error) {
            message.error(error?.message || error || "转交失败");
            console.error(error);
            cancelLoading();
          }
        },
        userData
      );
    },
    [reloadList, toggleSelect, userData]
  );

  const getChangeExtAccountStatu = useCallback(
    async (items: manageExternalInfo[], operate: any) => {
      if (!items.length) {
        message.error("至少选择一个用户");
        return;
      }
      if (operate.key === OperateEnum.notice) {
        // 提醒激活
        analysisLog("xtbg_add_home_1637657110163", "92");
        const [_res, err] = await sendActiveMsg({
          userId: items[0].userId,
          teamId: items[0].teamId
        });
        if (err) {
          message.error(err);
        } else {
          reloadList();
          message.success("已发送提醒激活短信");
        }
        return;
      }
      let optsContent = optTypeMap[operate.key];
      if (!optsContent) {
        return;
      }
      // 过滤;
      let filterdItems = items.filter((i) => {
        let allow = true;
        if (operate.key === OperateEnum.recovery) {
          if ((i.status & UserStatus.UN_ENABLE) !== UserStatus.UN_ENABLE) {
            return false;
          }
        }
        const typeDisallow = (disallowOpts as any)[operate.key];
        if (typeDisallow) {
          typeDisallow.forEach((type: UserStatus) => {
            if ((i.status & type) === type) {
              allow = false;
            }
          });
        }
        return allow;
      });
      if (!filterdItems.length) {
        message.error(`所选数据不能${optsContent.title}`);
        return;
      }
      if (operate.key === OperateEnum.transfer) {
        handleBatchTransfer(filterdItems);
        return;
      }

      if (operate.key === OperateEnum.delete) {
        setSelectedUser(filterdItems);
        setDeleteConfirmVisible(true);
        return;
      }
      const title = `即将${optsContent.title}<span class="primary">${filterdItems.length}</span>人，${optsContent.title}后：`;
      const confirmRes = await syncConfirmNew(
        <div>
          <div className="content-title" dangerouslySetInnerHTML={{ __html: title }} />
          <div
            dangerouslySetInnerHTML={{
              __html: optsContent.content
            }}
          />
        </div>,
        `账号${optsContent.title}`,
        {
          className: "external-confirm-modal-wrap task-common-modal-lb align-left",
          icon: null
        }
      );
      if (!confirmRes) {
        return;
      }
      operate.okClstag && analysisLog(operate.okClstag[0], operate.okClstag[1]);

      const [_result, error] = await changeExtAccountStatus({
        type: operate.type,
        userIds: filterdItems.map((i) => i.userId),
        teamId: filterdItems[0].teamId
      });
      if (error) {
        message.error(error);
        return;
      }
      reloadList();
      message.success("操作成功");
    },
    [handleBatchTransfer, reloadList]
  );

  const handleExtEmplOperateRecord = useCallback(async (item) => {
    const [result, error] = await getExtEmplOperateRecord({
      userId: item.userId,
      teamId: item.teamId
    });
    if (error) {
      message.error(error);
      return;
    }
    const { records, total } = result;
    item.open = true;
    item.records = records;
    forceUpdate();
  }, []);

  const getExtraPart = useCallback(
    (item: manageExternalInfo) => {
      if (selecting) {
        return (
          <span
            className="valid-date"
            style={{
              paddingRight: 200
            }}
          >
            {dayjs(item.validDate).format("YYYY-MM-DD")}到期
          </span>
        );
      }
      const operates = [];
      const status: number = item.status;
      if ((status & UserStatus.TRANSFERRING) !== UserStatus.TRANSFERRING) {
        if ((status & UserStatus.UN_ENABLE) !== UserStatus.UN_ENABLE) {
          operates.push({
            type: 4,
            key: OperateEnum.extend,
            name: "延期",
            okClstag: ["xtbg_add_home_1637657110163", "87"]
          });
        }
        if (
          (status & UserStatus.UN_ENABLE) !== UserStatus.UN_ENABLE &&
          (status & UserStatus.UN_ENABLE_EXPIRE) !== UserStatus.UN_ENABLE_EXPIRE
        ) {
          operates.push({
            type: 5,
            key: OperateEnum.stop,
            name: "停用",
            okClstag: ["xtbg_add_home_1637657110163", "88"]
          });
        }
        if ((status & UserStatus.UN_ENABLE) === UserStatus.UN_ENABLE) {
          operates.unshift({
            type: 6,
            name: "恢复",
            key: OperateEnum.recovery,
            okClstag: ["xtbg_add_home_1637657110163", "89"]
          });
        }

        operates.push(
          {
            name: "转交",
            key: OperateEnum.transfer,
            clstag: ""
          },
          {
            type: 8,
            key: OperateEnum.delete,
            name: "删除",
            clstag: ""
          }
        );
        if ((status & UserStatus.UN_ACTIVATE) === UserStatus.UN_ACTIVATE) {
          operates.unshift({
            key: OperateEnum.notice,
            name: "提醒激活",
            clstag: ""
          });
        }
      }

      return (
        <div
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
          }}
        >
          <span className="valid-date">{dayjs(item.validDate).format("YYYY-MM-DD")}到期</span>
          <span
            style={{
              padding: "10px  0  10px 10px",
              color: item.open ? "#999" : styles.color.primary2,
              cursor: item.open ? "auto" : "pointer"
            }}
            onClick={() => {
              if (item.open) return;
              handleExtEmplOperateRecord(item);
            }}
            clstag="pageclick|keycount|xtbg_add_home_1637657110163|61"
          >
            变更记录
          </span>

          {operates.length ? (
            <Dropdown
              disabled={selecting}
              overlay={
                <Menu>
                  {operates.map((i) => (
                    <Menu.Item
                      key={i.key}
                      onClick={() => {
                        getChangeExtAccountStatu([item], i);
                      }}
                      clstag={i.clstag || ""}
                    >
                      {i.name}
                    </Menu.Item>
                  ))}
                </Menu>
              }
              placement="bottomRight"
            >
              <span
                className="more-operation"
                style={{
                  marginLeft: "20px"
                }}
              >
                <IconFont type="iconlog_more" />
              </span>
            </Dropdown>
          ) : (
            <span style={{ display: "inline-block", width: "34px" }} />
          )}
        </div>
      );
    },
    [getChangeExtAccountStatu, selecting, handleExtEmplOperateRecord]
  );

  const TooltipTitle = useCallback(() => {
    return (
      <div className="Tooltip-title">
        您可对您邀请的和管理员分配的外部联系人账号进行管理，信息修改请联系单位管理员。
      </div>
    );
  }, []);

  const handleItemCheck = useCallback(
    (e: any) => {
      if (!e.checked) {
        selectedUser.push(e);
      } else {
        const userIndex = selectedUser.findIndex(
          (i: any) => convertUserToString(i) === convertUserToString(e)
        );
        if (userIndex >= 0) {
          selectedUser.splice(userIndex, 1);
        }
      }
      e.checked = !e.checked;
      forceUpdate();
    },
    [selectedUser]
  );
  const listItemNode = useCallback(
    (item: any, index: any) => {
      let newItem = item;
      if (newItem.avatar) {
        newItem.avatar = changeEgovUrl(newItem.avatar);
      }
      return (
        <div className="manage-external-item" key={index}>
          <ListItem
            checked={item.checked}
            checkable={selecting}
            onCheckChange={handleItemCheck}
            className="manage-external-user"
            data={newItem}
            extra={getExtraPart(item)}
            onClick={(item: ListItemData) => {
              analysisLog("xtbg_add_home_1637657110163", "73");
              openUserCardModal({ ...item, app: item.appId });
            }}
          />
          {item.open && (
            <>
              {item?.records.length ? (
                <div className="operation-record-list">
                  {item.records.map((ele: any, key: number) => {
                    return (
                      <div className="operation-record" key={key}>
                        <div>
                          <p className="operation-time">
                            {dayjs(ele.date).format("YYYY年MM月DD日 HH:mm")}
                          </p>
                          <p className="operation-name">操作人:{ele.operateName}</p>
                        </div>
                        <div className={ele.type !== 0 ? "split split_line" : "split"}>
                          <img src={operationRecord} alt="" />
                        </div>
                        <div>
                          <p className="delay-rejection">{operationType(ele.type)}</p>
                          <p
                            className="reject-reason"
                            dangerouslySetInnerHTML={{
                              __html: ele?.desc?.replace(/\n/g, "<br/>")
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="operation-record-list-nodata">暂无数据</div>
              )}
              <div
                className="close-record"
                onClick={() => {
                  item.open = !item.open;
                  manageExternalList.splice(index, 1, {
                    ...item,
                    open: false
                  });
                  forceUpdate();
                }}
              >
                收起 <IconFont type="iconicon_up" />
              </div>
            </>
          )}
        </div>
      );
    },
    [getExtraPart, handleItemCheck, manageExternalList, selecting]
  );

  const handleExpireTimeChange = useCallback((val: any) => {
    setExpireTime(val);
    analysisLog("xtbg_add_home_1637657110163", "86");
    setManageExternalList([]);
    page.current = 1;
  }, []);
  const handleStatusChange = useCallback((val: any) => {
    setStatus(val);
    analysisLog("xtbg_add_home_1637657110163", "85");
    setManageExternalList([]);
    page.current = 1;
  }, []);

  // debounce 搜索
  const handleSearch = useCallback(
    (val) => {
      analysisLog("xtbg_add_home_1637657110163", "84");
      page.current = 1;
      setManageExternalList([]);
      getManageExternalModalList(val);
    },
    [getManageExternalModalList]
  );
  const debouncedSearch = useMemo(() => debounce(handleSearch, 800), [handleSearch]);
  const handleSearchValChange = useCallback(
    (e) => {
      setSearchVal(e.target.value);
      debouncedSearch(e.target.value);
    },
    [debouncedSearch]
  );

  const handleAllCheck = useCallback(
    (e: any) => {
      batchList.forEach((i) => {
        i.checked = true;
      });
      if (e.target.checked) {
        setSelectedUser([...batchList]);
        batchList.forEach((i) => {
          i.checked = true;
        });
      } else {
        batchList.forEach((i) => {
          i.checked = false;
        });
        setSelectedUser([]);
      }
      forceUpdate();
    },
    [batchList]
  );

  const closeDeleteModal = useCallback(() => {
    setConfirmDelete(false);
    setDeleteConfirmVisible(false);
  }, []);
  const handleDelConfirmChange = useCallback((e: any) => {
    setConfirmDelete(e.target.checked);
  }, []);
  const executeDelete = useCallback(async () => {
    analysisLog("xtbg_add_home_1637657110163", "91");
    const [_result, error] = await changeExtAccountStatus({
      type: 8,
      userIds: selectedUser.map((i) => i.userId),
      teamId: selectedUser[0].teamId
    });
    if (error) {
      message.error(error);
      return;
    }
    message.success("操作成功");
    closeDeleteModal();
    reloadList();
  }, [closeDeleteModal, reloadList, selectedUser]);
  if (!visible) {
    return null;
  }
  return (
    <>
      <Modal
        title="账号删除"
        wrapClassName="external-delete-modal-wrap"
        centered
        visible={deleteConfirmVisible}
        onCancel={closeDeleteModal}
        footer={
          <div>
            <Button className="cancel-btn" onClick={closeDeleteModal}>
              取消
            </Button>
            <Tooltip placement="bottom" title={confirmDelete ? "直接删除" : "请先勾选风险提示"}>
              <Button type="primary" ghost disabled={!confirmDelete} onClick={executeDelete}>
                直接删除
              </Button>
            </Tooltip>
            <Button
              className="disable-btn"
              type="primary"
              onClick={() => {
                closeDeleteModal();
                getChangeExtAccountStatu(selectedUser, { key: "stop", type: 5 });
              }}
            >
              仅停用
            </Button>
          </div>
        }
      >
        <div className="content-title">
          即将删除
          <span className="primary">{selectedUser.length}</span>人，删除后：
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: optTypeMap.delete.content
          }}
        />
        <div>
          <Checkbox checked={confirmDelete} onChange={handleDelConfirmChange}>
            我已明确上述账号删除风险提示，确认要删除
          </Checkbox>
        </div>
      </Modal>
      <Modal
        title={
          <div className="manage-title">
            <span>
              {t("manageExternalModal.title")}
              <Tooltip placement="top" title={TooltipTitle}>
                <span style={{ marginLeft: "6px", fontSize: "12px" }}>
                  <QuestionCircleOutlined />
                </span>
              </Tooltip>
            </span>
            <span
              className="message-notice"
              onClick={debounce(() => {
                handleClose();
                const gatewayHost = new URL(gateway.protocol + "://" + gateway.host).origin;
                window.open(`${gatewayHost}/innerApp/userExternal#/approve-list`);
              }, 200)}
              clstag="pageclick|keycount|xtbg_add_home_1637657110163|83"
            >
              <IconFont type="iconzw_app_remind1" className="icon-notice" />
              审批列表
            </span>
          </div>
        }
        centered={true}
        visible={visible}
        onCancel={() => {
          handleClose();
        }}
        destroyOnClose
        footer={null}
        width="720px"
        bodyStyle={{ height: 580, padding: "10px 0px" }}
      >
        <div className="external-filter">
          <Input
            value={searchVal}
            readOnly={selecting}
            onChange={handleSearchValChange}
            className="filter-item"
            type="search"
            placeholder="搜索姓名、单位、职务"
          />
          <Select
            onChange={handleStatusChange}
            value={status}
            disabled={selecting}
            className="filter-item select-filter"
          >
            <Option value="">全部状态</Option>
            <Option value="1">未激活</Option>
            <Option value="2">正常</Option>
            <Option value="4">已停用</Option>
            <Option value="8">已过期</Option>
            <Option value="16">转交中</Option>
          </Select>
          <Select
            onChange={handleExpireTimeChange}
            value={expireTime}
            disabled={selecting}
            className="filter-item select-filter"
          >
            <Option value="">到期时间</Option>
            <Option value={dayjs().add(7, "day").endOf("day").valueOf().toString()}>近一周</Option>
            <Option value={dayjs().add(14, "day").endOf("day").valueOf().toString()}>近两周</Option>
            <Option value={dayjs().add(1, "month").endOf("day").valueOf().toString()}>
              近一个月
            </Option>
          </Select>
          <span className="toggle-filter filter-item" onClick={toggleSelect}>
            {selecting ? "取消" : "批量操作"}
          </span>
        </div>
        {manageExternalList.length || (selecting && batchList.length) ? (
          <div className="manage-external">
            {selecting && (
              <div className="batch-wrap">
                <div>
                  <Checkbox
                    checked={selectedUser.length === batchList.length}
                    onChange={handleAllCheck}
                    indeterminate={!!selectedUser.length && selectedUser.length < batchList.length}
                  >
                    全选
                  </Checkbox>
                  已选 {selectedUser.length}
                </div>
                <div className="batch-opts">
                  <Button
                    type="primary"
                    ghost
                    size="small"
                    onClick={getChangeExtAccountStatu.bind(null, selectedUser, {
                      key: "extend",
                      okClstag: ["xtbg_add_home_1637657110163", "87"],
                      type: 4
                    })}
                  >
                    延期
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    size="small"
                    onClick={getChangeExtAccountStatu.bind(null, selectedUser, {
                      key: "stop",
                      okClstag: ["xtbg_add_home_1637657110163", "88"],
                      type: 5
                    })}
                  >
                    停用
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    size="small"
                    onClick={getChangeExtAccountStatu.bind(null, selectedUser, {
                      key: "recovery",
                      okClstag: ["xtbg_add_home_1637657110163", "89"],
                      type: 6
                    })}
                  >
                    恢复
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    size="small"
                    onClick={() => {
                      handleBatchTransfer(selectedUser, true);
                    }}
                  >
                    转交
                  </Button>
                  <Button
                    type="primary"
                    ghost
                    size="small"
                    onClick={getChangeExtAccountStatu.bind(null, selectedUser, {
                      key: "delete",
                      type: 8
                    })}
                  >
                    删除
                  </Button>
                </div>
              </div>
            )}
            <div
              className={classnames("manage-external-list", {
                selecting: selecting
              })}
            >
              {(selecting ? batchList : manageExternalList).map(listItemNode)}
              {page.current * limit < total ? (
                <p
                  style={{ cursor: "pointer", textAlign: "center" }}
                  onClick={() => {
                    page.current += 1;
                    getManageExternalModalList(searchVal);
                  }}
                >
                  查看更多
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <Empty image={noContent} description="暂无数据" imageStyle={{ marginTop: 180 }} />
        )}
      </Modal>
    </>
  );
}

function mapStateToProps({ ebook, user }: { ebook: EbookState; user: UserState }) {
  return {
    userData: user.userData.user,
    manageExternalModal: ebook.manageExternalModal
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setManageExternalModal(payload: boolean) {
      dispatch({ type: "ebook/setManageExternalModal", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageExternal);
